import { render } from "./SwdWidgetTitle.vue?vue&type=template&id=9d884422"
import script from "./SwdWidgetTitle.vue?vue&type=script&lang=js"
export * from "./SwdWidgetTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__